
const GetPosterUrl = (path) => {
    return `https://www.themoviedb.org/t/p/w220_and_h330_face${path}`;
}

export default GetPosterUrl;
